import React, { useState } from "react";
import ModalBox from "./ModalBox";
import LogoModalHeader from "./LogoModalHeader";
import GoogleOAuthButton from "./GoogleOAuthButton";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "./AuthProvider";
import { subscribeEmail } from "../service/auth";
import { isValidEmail } from "../helpers/globals";
import { handleAuthSuccessRedirect } from "../utils/authRedirect";
import "./LoginModal.css";

function LoginModal({ onBack }) {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { handleSuccessfulSignup } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    // Validate email
    if (!email.trim()) {
      setError("Please enter your email address");
      return;
    }

    if (!isValidEmail(email)) {
      setError("Please enter a valid email address");
      return;
    }

    setIsLoading(true);

    try {
      // Log in with email
      const response = await subscribeEmail({
        email: email.trim(),
        newsletter_on: false,
      });

      // Store auth token and user data
      const token = response.data?.token || response.data?.data?.token || response.token;
      const userData = response.data?.data || response.data;

      if (token) {
        // Update auth state immediately
        handleSuccessfulSignup(token, userData);

        localStorage.setItem("hasCreatedAccount", "true");

        handleAuthSuccessRedirect(navigate, location);
      } else {
        throw new Error("Invalid response from login API");
      }
    } catch (err) {
      console.error("Email login error:", err);
      setError(
        err.response?.data?.message ||
        err.message ||
        "Failed to log in. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ModalBox open onClose={() => { }} backdrop="static" keyboard={false}>
      <div className="login-modal-wrapper">
        <LogoModalHeader />

        {/* Headline */}
        <h1 className="login-modal-headline font-eagle-bold">Welcome Back</h1>

        {/* Google OAuth Button */}
        <GoogleOAuthButton />

        {/* Email Login Form */}
        <form className="login-modal-form" onSubmit={handleSubmit}>
          <input
            type="email"
            className="login-modal-input"
            placeholder="Type email here"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={isLoading}
            autoComplete="email"
          />
          <button
            type="submit"
            className="login-modal-submit-button"
            disabled={isLoading}
          >
            {isLoading ? "Signing in..." : "Sign In"}
          </button>
          {error && <div className="login-modal-error">{error}</div>}
        </form>

        {/* Terms of Service */}
        <div className="login-modal-terms">
          By signing in, you agree to our{" "}
          <Link to="/terms" target="_blank" rel="noopener noreferrer">
            Terms of Service
          </Link>
          .
        </div>
      </div>
    </ModalBox>
  );
}

export default LoginModal;
